import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const AdditionalPaymentCategoryParamsSchema = object({
  additionalPaymentCategoryId: stringToNumber()
})
